export const ORDERS = Object.freeze({
    CANVAS_DATA_LAST_UPDATE: 'canvasDataUpdatedAt',
    CREATION_DATE: 'createdAt',
});

export const ORDERS_OPTIONS = Object.freeze([
    { value: ORDERS.CANVAS_DATA_LAST_UPDATE, label: 'Last Update' },
    { value: ORDERS.CREATION_DATE, label: 'Creation Date' },
]);
